import { render } from "./RedText.vue?vue&type=template&id=088fddb0&ts=true"
import script from "./RedText.vue?vue&type=script&lang=ts"
export * from "./RedText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__